mutation unassignUser($leadId: String!) {
  unassignUserFromLead(leadId: $leadId)
}
